import UserActions from "../Types";
import responseHandler from "../../utils/responseHandler";
import Instance from "../../utils/api";
import Instance2 from "../../utils/apiCert";
import Storage from "../../utils/storage";

// REGISTER A USER
export const registerUserStart = () => ({
  type: UserActions.USER_REGISTER_START,
});

export const registerUserSuccess = (payload) => ({
  type: UserActions.USER_REGISTER_SUCCESS,
  payload,
});

export const registerUserFailure = (payload) => ({
  type: UserActions.USER_REGISTER_FAILURE,
  payload,
});

// VERIFY EMAIL
export const verifyEmailStart = () => ({
  type: UserActions.VERIFY_EMAIL_START,
});

export const verifyEmailSuccess = (payload) => ({
  type: UserActions.VERIFY_EMAIL_SUCCESS,
  payload,
});

export const verifyEmailFailure = (payload) => ({
  type: UserActions.VERIFY_EMAIL_FAILURE,
  payload,
});

// RESEND VERIFICATION EMAIL
export const resendVerificationStart = () => ({
  type: UserActions.RESEND_VERIFICATION_START,
});

export const resendVerificationSuccess = (payload) => ({
  type: UserActions.RESEND_VERIFICATION_SUCCESS,
  payload,
});

export const resendVerificationFailure = (payload) => ({
  type: UserActions.RESEND_VERIFICATION_FAILURE,
  payload,
});

// ADD A STAFF
export const addStaffStart = () => ({
  type: UserActions.ADD_STAFF_START,
});

export const addStaffSuccess = (payload) => ({
  type: UserActions.ADD_STAFF_SUCCESS,
  payload,
});

export const addStaffFailure = (payload) => ({
  type: UserActions.ADD_STAFF_FAILURE,
  payload,
});

// GET ALL STAFFS
export const getAllStaffStart = () => ({
  type: UserActions.GET_ALL_STAFF_START,
});

export const getAllStaffSuccess = (payload) => ({
  type: UserActions.GET_ALL_STAFF_SUCCESS,
  payload,
});

export const getAllStaffFailure = (payload) => ({
  type: UserActions.GET_ALL_STAFF_FAILURE,
  payload,
});

// EDIT A STAFF
export const editStaffStart = () => ({
  type: UserActions.EDIT_STAFF_START,
});

export const editStaffSuccess = (payload) => ({
  type: UserActions.EDIT_STAFF_SUCCESS,
  payload,
});

export const editStaffFailure = (payload) => ({
  type: UserActions.EDIT_STAFF_FAILURE,
  payload,
});

// DELETE A STAFF
export const deleteStaffStart = () => ({
  type: UserActions.DELETE_STAFF_START,
});

export const deleteStaffSuccess = (payload) => ({
  type: UserActions.DELETE_STAFF_SUCCESS,
  payload,
});

export const deleteStaffFailure = (payload) => ({
  type: UserActions.DELETE_STAFF_FAILURE,
  payload,
});

// CHANGE PASSWORD
export const changePasswordStart = () => ({
  type: UserActions.CHANGE_PASSWORD_START,
});

export const changePasswordSuccess = (payload) => ({
  type: UserActions.CHANGE_PASSWORD_SUCCESS,
  payload,
});

export const changePasswordFailure = (payload) => ({
  type: UserActions.CHANGE_PASSWORD_FAILURE,
  payload,
});

// UPDATE A USER
export const updateUserStart = () => ({
  type: UserActions.UPDATE_USER_START,
});

export const updateUserSuccess = (payload) => ({
  type: UserActions.UPDATE_USER_SUCCESS,
  payload,
});

export const updateUserFailure = (payload) => ({
  type: UserActions.UPDATE_USER_FAILURE,
  payload,
});
// UPLOAD DOCUMENT
export const uploadStart = () => ({
  type: UserActions.UPLOAD_DOC_START,
});

export const uploadSuccess = (payload) => ({
  type: UserActions.UPLOAD_DOC_SUCCESS,
  payload,
});

export const uploadFailure = (payload) => ({
  type: UserActions.UPLOAD_DOC_FAILURE,
  payload,
});

export const uploadReset = () => ({
  type: UserActions.UPLOAD_DOC_RESET,
});

export const resetUser = () => ({
  type: UserActions.RESET_USER_RESET,
});

// UPDATE DOCUMENT
export const updateDocStart = () => ({
  type: UserActions.UPDATE_DOC_START,
});

export const updateDocSuccess = (payload) => ({
  type: UserActions.UPDATE_DOC_SUCCESS,
  payload,
});

export const updateDocFailure = () => ({
  type: UserActions.UPDATE_DOC_FAILURE,
});

// GET DEMO MONTHS
export const getDemoMonthsStart = () => ({
  type: UserActions.GET_DEMO_MONTHS_START,
});

export const getDemoMonthsSuccess = (payload) => ({
  type: UserActions.GET_DEMO_MONTHS_SUCCESS,
  payload,
});

export const getDemoMonthsFailure = (payload) => ({
  type: UserActions.GET_DEMO_MONTHS_FAILURE,
  payload,
});

// GET DEMO DAYS
export const getDemoDaysStart = () => ({
  type: UserActions.GET_DEMO_DAYS_START,
});

export const getDemoDaysSuccess = (payload) => ({
  type: UserActions.GET_DEMO_DAYS_SUCCESS,
  payload,
});

export const getDemoDaysFailure = (payload) => ({
  type: UserActions.GET_DEMO_DAYS_FAILURE,
  payload,
});

// GET DEMO SLOTS
export const getDemoSlotStart = () => ({
  type: UserActions.GET_DEMO_SLOT_START,
});

export const getDemoSlotSuccess = (payload) => ({
  type: UserActions.GET_DEMO_SLOT_SUCCESS,
  payload,
});

export const getDemoSlotFailure = (payload) => ({
  type: UserActions.GET_DEMO_SLOT_FAILURE,
  payload,
});

// BOOK SLOT
export const bookSlotStart = () => ({
  type: UserActions.BOOK_SLOT_START,
});

export const bookSlotSuccess = (payload) => {
  return {
    type: UserActions.BOOK_SLOT_SUCCESS,
    payload,
  };
};

export const bookSlotFailure = (payload) => ({
  type: UserActions.BOOK_SLOT_FAILURE,
  payload,
});

// CLEAR DEMO STATE
export const clearDemoState = () => ({
  type: UserActions.CLEAR_DEMO_STATE,
});

// CLEAR VERIRY EMAIL STATE
export const clearVerifyEmailState = () => ({
  type: UserActions.CLEAR_VERIFY_EMAIL_STATE,
});

export const registerUser = (payload) => async (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));
  dispatch(registerUserStart());
  API.post("company/signup", payload).then((response) => {
    const { data, ok } = response;
    responseHandler(response);
    if (ok) {
      dispatch(registerUserSuccess(data));
    } else {
      dispatch(registerUserFailure(data));
    }
  });
};

export const verifyEmail = (payload) => async (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));
  dispatch(verifyEmailStart());
  API.post("company/email/verify", payload).then((response) => {
    const { data, ok } = response;
    responseHandler(response);
    if (ok) {
      dispatch(verifyEmailSuccess(data.success));
    } else {
      dispatch(verifyEmailFailure(data));
    }
  });
};

export const reVerifyEmail = (payload) => async (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));
  dispatch(resendVerificationStart());
  API.post("resend-verification-email", payload).then((response) => {
    const { data, ok } = response;
    responseHandler(response);
    if (ok) {
      dispatch(resendVerificationSuccess(data));
    } else {
      dispatch(resendVerificationFailure(data));
    }
  });
};

export const addStaff = (payload) => async (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));
  dispatch(addStaffStart());
  API.post("staff/signup", payload).then((response) => {
    const { data, ok } = response;
    responseHandler(response);
    if (ok) {
      dispatch(addStaffSuccess(data.success));
    } else {
      dispatch(addStaffFailure(data));
    }
  });
};

export const getAllStaffs = (offset, limit) => async (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));
  dispatch(getAllStaffStart());
  API.get(`staff?offset=${offset}&limit=${limit}`).then((response) => {
    const { data, ok } = response;
    responseHandler(response);
    if (ok) {
      dispatch(getAllStaffSuccess(data.data));
    } else {
      dispatch(getAllStaffFailure(data));
    }
  });
};

export const editStaff = (id, payload) => async (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));
  dispatch(editStaffStart());
  API.put(`staff/${id}`, payload).then((response) => {
    const { data, ok } = response;
    responseHandler(response);
    if (ok) {
      dispatch(editStaffSuccess(data.success));
    } else {
      dispatch(editStaffFailure(data));
    }
  });
};

export const deleteStaff = (id, payload) => async (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));
  dispatch(deleteStaffStart());
  API.delete(`staff/${id}`, payload).then((response) => {
    const { data, ok } = response;
    responseHandler(response);
    if (ok) {
      dispatch(deleteStaffSuccess(data.success));
    } else {
      dispatch(deleteStaffFailure(data));
    }
  });
};

export const changePassword = (payload) => async (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));
  dispatch(changePasswordStart());
  API.post("auth/password/change", payload).then((response) => {
    const { data, ok } = response;
    responseHandler(response);
    if (ok) {
      dispatch(changePasswordSuccess(data.success));
      Storage.set("staffPassword", new Date())
    } else {
      dispatch(changePasswordFailure(data));
    }
  });
};

export const updateUser = (payload) => async (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));
  dispatch(updateUserStart());
  API.put("company/email", payload).then((response) => {
    const { data, ok } = response;
    responseHandler(response);
    if (ok) {
      dispatch(updateUserSuccess(data.data));
    } else {
      dispatch(updateUserFailure(data));
    }
  });
};

export const uploadDoc = (payload) => async (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));
  dispatch(uploadStart());
  API.post("application/", payload).then((response) => {
    const { data, ok } = response;
    responseHandler(response);
    if (ok) {
      dispatch(uploadSuccess(data));
    } else {
      dispatch(uploadFailure(data));
    }
  });
};

export const updateDoc = (payload) => async (dispatch) => {
  const API = Instance.customAxiosInstance(Storage.get("user-access-token"));
  dispatch(updateDocStart());
  API.put("application/", payload).then((response) => {
    const { data, ok } = response;
    responseHandler(response);
    if (ok) {
      dispatch(updateDocSuccess(data));
    } else {
      dispatch(updateDocFailure(data));
    }
  });
};

export const getDemoSlots = (payload) => async (dispatch) => {
  const API = Instance2.customAxiosInstance(Storage.get("user-access-token"));
  dispatch(getDemoSlotStart());
  API.post("demo/slot", payload).then((response) => {
    const { data, ok } = response;
    responseHandler(response);
    if (ok) {
      dispatch(getDemoSlotSuccess(data.data));
    } else {
      dispatch(getDemoSlotFailure(data));
    }
  });
};

export const getDemoMonths = () => async (dispatch) => {
  const API = Instance2.customAxiosInstance(Storage.get("user-access-token"));
  dispatch(getDemoMonthsStart());
  API.get("demo/month").then((response) => {
    const { data, ok } = response;
    responseHandler(response);
    if (ok) {
      dispatch(getDemoMonthsSuccess(data.data));
    } else {
      dispatch(getDemoMonthsFailure(data));
    }
  });
};

export const getDemoDays = (payload) => async (dispatch) => {
  const API = Instance2.customAxiosInstance(Storage.get("user-access-token"));
  dispatch(getDemoDaysStart());
  API.post("demo/month/days", payload).then((response) => {
    const { data, ok } = response;
    responseHandler(response);
    if (ok) {
      dispatch(getDemoDaysSuccess(data.data));
    } else {
      dispatch(getDemoDaysFailure(data));
    }
  });
};

export const bookSlot = (payload) => async (dispatch) => {
  const API = Instance2.customAxiosInstance(Storage.get("user-access-token"));
  dispatch(bookSlotStart());
  API.post("demo/event", payload).then((response) => {
    const { data, ok } = response;
    responseHandler(response);
    if (ok) {
      dispatch(bookSlotSuccess(data));
      dispatch(clearDemoState());
    } else {
      dispatch(bookSlotFailure(data));
    }
  });
};